import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';

import OneVisualLayout from '../../layouts/one-visual';

import Image from '../../../../../containers/assets/instructor-successful-teams1.png'

class SuccessfulStep1 extends PureComponent {
  render() {
    return (
      <OneVisualLayout
        section="Successful Teams"
        title="Reason Why Teams Hit Their Targets"
        paragraph1={(
          <Fragment>
            <p>Teams that were successful in Round 1 did 2 things very well - they built demand and had supply.</p>
            <p>On the demand side, they leveraged data from the <a href="/">Customer Analysis page</a> to develop a Marketing Mix that were aligned with customers’ preferences. On the supply side,  they acquired and utilized machines that allowed them to have sufficient inventory available for sale.</p>
          </Fragment>
        )}
        visual={(
          <img src={Image} alt="Marketing Mix" />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }
}

export default SuccessfulStep1;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/successful-teams/step1.js